import React from "react";

function ProductsDescriptionHtml(props) {
  return <div dangerouslySetInnerHTML={{ __html: props.html }} />;
}

export default ProductsDescriptionHtml;
